export default function Ayuda() {
  // El PDF se sirve como archivo estático desde /manual/manual-usuario.pdf
  const manualUrl = '/manual/manual-usuario.pdf';

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">
        Centro de Ayuda
      </h1>
      <p className="text-gray-600 mb-6">
        Consulta el manual de usuario del sistema. Puedes verlo en línea
        o descargarlo para imprimirlo.
      </p>

      <div className="bg-white rounded-xl shadow-sm border p-6 flex flex-col gap-4">
        <div className="flex items-center gap-3">
          <span className="text-3xl">📘</span>
          <div>
            <h2 className="font-semibold text-lg">
              Manual de Usuario — Sistema Camaronera
            </h2>
            <p className="text-sm text-gray-500">
              Versión 1.0 · Octubre 2026 · PDF
            </p>
          </div>
        </div>

        <div className="flex gap-3 flex-wrap">
          <a
            href={manualUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition"
          >
            👁️ Ver en línea
          </a>
          <a
            href={manualUrl}
            download
            className="px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50 transition"
          >
            ⬇️ Descargar PDF
          </a>
        </div>
      </div>

      <div className="mt-6 bg-blue-50 border border-blue-200 rounded-xl p-4 text-sm text-blue-900">
        <strong>💡 Tip:</strong> si tienes dudas sobre tu rol o permisos,
        contacta al administrador de tu finca desde
        <em> Configuración → Usuarios</em>.
      </div>
    </div>
  );
}